// extracted by mini-css-extract-plugin
export var actionButton = "_91-0";
export var attachmentLine = "_91-1";
export var fileInput = "_91-2";
export var fileUploadWrapper = "_91-4";
export var footer = "_91-3";
export var modalContent = "_91-5";
export var paperclip = "_91-6";
export var quillEditor = "_91-7";